import { CommonModule, TitleCasePipe, LowerCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
  MatLegacyPaginatorModule as MatPaginatorModule,
  MatLegacyPaginatorIntl as MatPaginatorIntl,
} from '@angular/material/legacy-paginator';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MAT_LEGACY_SNACK_BAR_DEFAULT_OPTIONS as MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/legacy-snack-bar';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';
import { DATE_FORMAT } from '../shared/constants/date-format.constant';
import { CustomMatPaginatorIntl } from '../content-list-management/shared/custom-mat-paginator-intl';
import { SharedModule } from '../shared/shared.module';
import { ManagerDashboardComponent } from './manager-dashboard/manager-dashboard.component';
import { ManagerContentRoutingModule } from './manager-content-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { AutoCompleteComponent } from '../shared-form-sections/components/auto-complete/auto-complete.component';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { ManagerProfileComponent } from './manager-profile/manager-profile.component';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedFormSectionsModule } from '../shared-form-sections/shared-form-sections.module';

@NgModule({
  declarations: [ManagerDashboardComponent, ManagerProfileComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    SharedModule,
    ManagerContentRoutingModule,
    MatIconModule,
    AutoCompleteComponent,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatTabsModule,
    ReactiveFormsModule,
    SharedFormSectionsModule,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    TitleCasePipe,
    LowerCasePipe,
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { duration: 3000, panelClass: 'notification-panel' },
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
  ],
})
export class ManagerContentModule {}
